<template>
  <a
    :href="nav.href ? nav.href : 'javascript:;'"
    class="nav-link x-link-active"
    @click="handleClick"
  >
      <NavIcon :image="nav.image" />
      <div class="nav--label">
        {{ nav.text }}
      </div>
      <Tag
        v-if="nav.flagText === 'New'"
        class="nav--tag"
      >
        New
      </Tag>
  </a>
</template>

<script>
import Tag from 'wap/components/Tag.vue'
import NavIcon from './NavIcon.vue'

export default {
  components: {
    Tag,
    NavIcon
  },
  props: {
    nav: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    handleClick () {
      this.$emit('click')
    }
  }
}
</script>

<style lang="scss" scoped>
.nav-link {
  position: relative;
  display: flex;
  overflow: hidden;
  height: 100%;
  box-sizing: border-box;
  flex: 1;
  flex-direction: column;
  align-items: center;
  padding-top: 13px;
  padding-bottom: 14px;
  border-radius: 8px;
  text-align: center;

  .nav--label {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 6px;
    color: #fff;
    font-family: Roboto;
    font-size: 10px;
    letter-spacing: -0.22px;
    line-height: 12px;
    text-transform: capitalize;
  }

  .nav--tag {
    top: 2px;
    right: 10px;
    height: 14px;
    border-radius: 7px 7px 7px 0;
    line-height: 14px;
  }
}

[data-mode="light"] .nav-link {
  .nav--label {
    color: #000;
  }
}
</style>
